import React, { useEffect } from "react";
import { Navbar } from "@/components/Navbar";
import { CheckCircle2 } from "lucide-react";

const RULES = [
  ["One account per person or business", "Each individual or business may hold a single PodiumOne account. Duplicate or sockpuppet accounts are prohibited."],
  ["No fake or misleading business names", "Listings must use a real, accurate business or creator name. Impersonation or deceptive names are not allowed."],
  ["No shill bidding", "You may not use secondary accounts or coordinate with others to artificially inflate bids or manipulate rankings."],
  ["A funded wallet is required before bidding", "You bid from a prepaid wallet on both boards. Global (USD) top-ups and Malaysia (/my, MYR) top-ups via FPX or GrabPay fund your wallet. New accounts start with a signup bonus ($10 Global / RM 5 Malaysia)."],
  ["One-time Spot Price to place a bid", "Placing a bid deducts a flat one-time Spot Price from your wallet ($5.00 Global / RM 5 Malaysia) and sets your starting Locked Bid. There are no recurring or daily charges — your bid is permanent."],
  ["Outbid by raising your Locked Bid", "To climb the ranks, raise your Locked Bid above the current #1. You pay only the difference (the delta) from your wallet, one time. Ranking is a simple highest-Locked-Bid-wins order."],
  ["Brand Lock requires manual verification", "Brand Lock applications are reviewed and approved manually by an admin. Submitting an application does not guarantee approval."],
  ["We may remove violating listings", "PodiumOne reserves the right to remove any listing, bid, or account that violates these rules, at our discretion and without notice."],
];

export default function Rules() {
  useEffect(() => { document.title = "Rules — PodiumOne"; }, []);
  return (
    <div>
      <Navbar />
      <div className="relative z-10 max-w-3xl mx-auto px-4 pt-28 pb-16">
        <span className="text-xs font-bold uppercase tracking-[0.25em] text-white/40">Platform rules</span>
        <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tighter mt-2 mb-4">Fair play on PodiumOne</h1>
        <p className="text-white/60 text-lg mb-10">These rules keep the leaderboards honest for everyone. By using PodiumOne you agree to follow them.</p>
        <div className="space-y-4">
          {RULES.map(([title, body], i) => (
            <div key={i} className="glass rounded-2xl p-6 flex gap-4" data-testid="rule-item">
              <CheckCircle2 className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" />
              <div>
                <h2 className="font-semibold text-lg">{title}</h2>
                <p className="text-white/60 mt-1 leading-relaxed">{body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
